import Header2 from 'elements/Header2';
import ds from 'designsystem';

const Header = Header2.extend`
    margin: 0;
    margin-bottom: ${ds.get('metrics.s')};
`;

export default Header;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Banner/Header.jsx